import CheckedIcon from "@mui/icons-material/CheckCircle";
import DetailsIcon from "@mui/icons-material/Details";
import UncheckedIcon from "@mui/icons-material/HighlightOff";
import { useTheme } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import OmniAvatar from "./omniAvatar";
import OmniListItemButton from "./omniListItemButton";

const OmniAssessmentTypeListItem = props => {
  const {
    assessmentTypeDef,
    isChecked = false,
    onClickHandler = null,
    onNavigateHandler = null,
  } = props;
  const theme = useTheme();

  const getSelectedIcon = checked => {
    if (checked) {
      return <CheckedIcon />;
    } else {
      return <UncheckedIcon />;
    }
  };

  return (
    <ListItem
      disableGutters={true}
      sx={{
        padding: theme.spacing(1),
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: theme.spacing(1),
        borderRadius: theme.spacing(1),
        backgroundColor: isChecked ? theme.palette.success.main : theme.palette.warning.main,
        // backgroundColor: alpha(theme.palette.info.main, 0.75),
        color: theme.palette.info.contrastText,
        cursor: "pointer",
        boxShadow: theme.shadows[3],
        userSelect: "none",
        webkitUserSelect: "none",
      }}
      onClick={e => {
        e.stopPropagation();
        if (onClickHandler) {
          onClickHandler(assessmentTypeDef.value);
        }
      }}
    >
      <Tooltip title={"Click to Toggle"} placement="right">
        <>
          <OmniAvatar
            sx={{
              width: 36,
              height: 36,
              fontSize: "1.2rem",
              backgroundColor: isChecked
                ? theme.palette.success.contrastText
                : theme.palette.warning.contrastText,
              color: isChecked ? theme.palette.success.main : theme.palette.warning.main,

              border: `2px solid ${theme.palette.info.contrastText}`,
            }}
          >
            {getSelectedIcon(isChecked)}
          </OmniAvatar>
        </>
      </Tooltip>
      <ListItemText
        primary={
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              flexDirection: "column",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: theme.palette.info.contrastText,
              marginTop: 0,
            }}
          >
            {assessmentTypeDef.label}
          </Typography>
        }
        secondary={
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              flexDirection: "row",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginTop: "-6px",
              color: theme.palette.info.contrastText,
              minimumHeight: 20,
            }}
          >
            {assessmentTypeDef.info}
          </Typography>
        }
      />
      {onNavigateHandler && (
        <OmniListItemButton
          title={"Check Status"}
          sx={{
            marginTop: "1px",
            marginRight: "1px",
          }}
          size="large"
          onClick={e => {
            e.stopPropagation();
            //  window.location.reload();
            //todo ImplmentNavigation
          }}
          icon={<DetailsIcon />}
        />
      )}
    </ListItem>
  );
};

export default OmniAssessmentTypeListItem;
